<!-- Back Navigation -->
<div class="mb-4">
  <a routerLink="/maintenance/service-appointments" class="text-decoration-none">
    <i class="bi bi-arrow-left me-1"></i>Back to Service Appointments
  </a>
</div>

<!-- Loading State -->
<div *ngIf="isLoading" class="d-flex justify-content-center py-5">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<ng-container *ngIf="appointment && !isLoading">
  <!-- Page Header -->
  <div class="d-flex justify-content-between align-items-start mb-4">
    <div>
      <h1 class="h2 mb-1 fw-bold">Service Appointment</h1>
      <p class="text-muted mb-0">
        Requested {{ formatDate(appointment.createdAt) }}
      </p>
    </div>
    <span class="badge fs-6 py-2 px-3" [ngClass]="getStatusBadgeClass(appointment.status)">
      {{ getStatusText(appointment.status) }}
    </span>
  </div>

  <div class="row g-4">
    <!-- Main Details -->
    <div class="col-12 col-lg-8">
      <div class="card">
        <div class="card-header p-3">
          <h5 class="mb-0 fw-bold">Appointment Details</h5>
        </div>
        <div class="card-body p-3">
          <!-- Schedule Info -->
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label text-muted small mb-0">Preferred Date</label>
              <p class="mb-0 fw-medium">{{ formatDate(appointment.preferredDate) }}</p>
            </div>
            <div class="col-sm-4">
              <label class="form-label text-muted small mb-0">Preferred Time</label>
              <p class="mb-0 fw-medium">{{ getPreferredTimeLabel(appointment.preferredTime) }}</p>
            </div>
            <div class="col-sm-4" *ngIf="appointment.scheduledDate">
              <label class="form-label text-muted small mb-0">Scheduled Date</label>
              <p class="mb-0 fw-medium">{{ formatDateTime(appointment.scheduledDate) }}</p>
            </div>
          </div>

          <!-- Drone Info -->
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label text-muted small mb-0">Drone</label>
              <p class="mb-0 fw-medium">{{ appointment.droneName || 'Unknown' }}</p>
            </div>
            <div class="col-sm-4" *ngIf="appointment.droneSerialNumber">
              <label class="form-label text-muted small mb-0">Serial Number</label>
              <p class="mb-0 fw-medium">{{ appointment.droneSerialNumber }}</p>
            </div>
            <div class="col-sm-4">
              <label class="form-label text-muted small mb-0">Technician</label>
              <p class="mb-0 fw-medium">{{ appointment.technicianName || 'Pending Assignment' }}</p>
            </div>
          </div>

          <!-- Issue Description -->
          <div class="mb-3">
            <label class="form-label text-muted small mb-1">Issue Description</label>
            <p class="mb-0 text-pre-wrap">{{ appointment.issueDescription }}</p>
          </div>

          <!-- Notes -->
          <div class="mb-3" *ngIf="appointment.notes">
            <label class="form-label text-muted small mb-1">Notes</label>
            <p class="mb-0 text-pre-wrap">{{ appointment.notes }}</p>
          </div>

          <!-- Cancellation Info -->
          <div class="alert alert-secondary mt-3 mb-0" *ngIf="appointment.status === 'cancelled' && appointment.cancelledReason">
            <strong>Cancellation Reason:</strong>
            <p class="mb-0 mt-1">{{ appointment.cancelledReason }}</p>
            <small class="text-muted d-block mt-1" *ngIf="appointment.cancelledAt">Cancelled {{ formatDateTime(appointment.cancelledAt) }}</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Sidebar -->
    <div class="col-12 col-lg-4">
      <!-- Actions Card -->
      <div class="card mb-3" *ngIf="isCancellable">
        <div class="card-header p-3">
          <h6 class="mb-0 fw-bold">Actions</h6>
        </div>
        <div class="card-body p-3">
          <ng-container *ngIf="!showCancelForm">
            <button class="btn btn-outline-danger btn-sm w-100" (click)="toggleCancelForm()">
              <i class="bi bi-x-circle me-1"></i>Cancel Appointment
            </button>
          </ng-container>
          <ng-container *ngIf="showCancelForm">
            <div>
              <label class="form-label small">Reason for cancellation <span class="text-danger">*</span></label>
              <textarea appCharCounter
                class="form-control form-control-sm mb-2"
                rows="3"
                placeholder="Please provide a reason..."
                [(ngModel)]="cancelReason"
                [disabled]="isCancelling"
              ></textarea>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-danger btn-sm flex-fill"
                  [disabled]="!cancelReason.trim() || isCancelling"
                  (click)="confirmCancel()"
                >
                  <span *ngIf="isCancelling" class="spinner-border spinner-border-sm me-1"></span>
                  Confirm
                </button>
                <button class="btn btn-outline-secondary btn-sm" (click)="toggleCancelForm()" [disabled]="isCancelling">
                  Nevermind
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Audit Info Card -->
      <div class="card">
        <div class="card-header p-3">
          <h6 class="mb-0 fw-bold">Details</h6>
        </div>
        <div class="card-body p-3">
          <div class="mb-2">
            <small class="text-muted d-block">Created By</small>
            <span class="small fw-medium">{{ appointment.createdByName || 'Unknown' }}</span>
          </div>
          <div class="mb-2">
            <small class="text-muted d-block">Created</small>
            <span class="small fw-medium">{{ formatDateTime(appointment.createdAt) }}</span>
          </div>
          <div>
            <small class="text-muted d-block">Last Updated</small>
            <span class="small fw-medium">{{ formatDateTime(appointment.updatedAt) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
